<template>
    <div class="block-editor table-find-record">
        <div class="wrapper">
            <!-- Tablo Seçimi -->
            <section>
                <div class="editor-row-title">Tablo Seç</div>
                <CustomPicker
                    v-model="clone.tableId"
                    :items="tables"
                    idKey="_id"
                    labelKey="name"
                    title="Tablo Seç"
                    @change="onTableChange"
                />
            </section>

            <!-- Filtreler -->
            <section v-if="getSelectedTable()">
                <div class="title">Filtreler</div>
                <div class="filter-actions">
                    <a-button type="dashed" icon="plus" @click="addFilter"> Koşul Ekle</a-button>
                </div>
                <div class="filter-conditions">
                    <div class="filter-row" v-for="(filter, index) in clone.filters" :key="index">
                        <!-- Alan Seçimi -->
                        <CustomPicker
                            v-model="clone.filters[index].fieldId"
                            :items="getFields()"
                            idKey="_id"
                            labelKey="name"
                            title="Alan"
                            :icon="getFieldIcon(filter.fieldId)"
                            style="width: 20%; margin-right: 8px"
                            @change="onFieldChange(filter)"
                        />
                        <!-- Operatör Seçimi -->
                        <CustomPicker
                            v-model="clone.filters[index].operator"
                            :items="getOperators(filter)"
                            idKey="value"
                            labelKey="label"
                            title="Operatör"
                            icon="filter_list"
                            style="width: 15%; margin-right: 8px"
                            :disabled="!filter.fieldId"
                        />
                        <!-- Statik/Dinamik Mod Seçimi -->
                        <div v-if="['checkbox', 'dropdown'].includes(getFieldType(filter.fieldId))" class="mode-switch">
                            <a-tooltip>
                                <template #title>
                                    Statik mod: Önceden tanımlanmış değerleri kullanır<br />
                                    Dinamik mod: Değişkenleri veya kullanıcı girdilerini kullanır
                                </template>
                                <a-switch
                                    :checked="filter.mode === 'static'"
                                    @change="onModeChange(index, $event)"
                                    size="small"
                                >
                                    <span slot="checkedChildren">Statik</span>
                                    <span slot="unCheckedChildren">Dinamik</span>
                                </a-switch>
                            </a-tooltip>
                        </div>
                        <!-- Değer Girişi -->
                        <!-- Statik Mod -->
                        <component
                            v-if="filter.mode === 'static'"
                            :is="getValueInputComponent(filter)"
                            v-model="clone.filters[index].value"
                            :options="getFieldOptions(filter)"
                            style="width: 30%; margin-right: 8px"
                            :placeholder="'Değer'"
                            :disabled="!filter.operator"
                        ></component>
                        <!-- Dinamik Mod -->
                        <div v-else class="text-editor-wrapper">
                            <TiptapEditor
                                :placeholder="'Değer'"
                                :show-attributes="true"
                                :show-emoji="true"
                                :max-character-count="1024"
                                v-model="clone.filters[index].value"
                            />
                        </div>
                        <!-- Filtreyi Kaldır -->
                        <a-button type="danger" icon="delete" @click="removeFilter(index)" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import { Input, Select, DatePicker, InputNumber, Button, Tooltip, Switch } from "ant-design-vue";
import log2 from "../../../../../../../utils/log2";

const log = log2("FindRecord");
export default Vue.extend({
    name: "FindRecord",
    components: {
        CustomPicker,
        TiptapEditor,
        "a-input": Input,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-date-picker": DatePicker,
        "a-input-number": InputNumber,
        "a-button": Button,
        "a-tooltip": Tooltip,
        "a-switch": Switch,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                log("clone changed", newValue);
                this.$emit("input", newValue);
            },
        },
    },
    created() {
        if (!this.clone.filters) {
            this.$set(this.clone, "filters", []);
        }
    },
    methods: {
        getSelectedTable() {
            return this.tables.find((table) => table._id === this.clone.tableId);
        },
        onTableChange(tableId) {
            if (this.clone.filters.length > 0) {
                this.$confirm({
                    title: "Emin misiniz?",
                    content: "Tabloyu değiştirmek tüm filtreleri silecek. Devam etmek istiyor musunuz?",
                    onOk: () => {
                        this.clone.tableId = tableId;
                        this.clone.filters = [];
                    },
                    onCancel: () => {
                        this.clone.tableId = this.value.tableId;
                    },
                });
            } else {
                this.clone.tableId = tableId;
                this.clone.filters = [];
            }
        },

        getFields() {
            const table = this.getSelectedTable();
            return table ? table.fields : [];
        },
        getField(fieldId) {
            return this.getFields().find((field) => field._id === fieldId);
        },
        getFieldType(fieldId) {
            const field = this.getField(fieldId);
            return field ? field.fieldType : "";
        },
        getFieldValueType(fieldId) {
            const field = this.getField(fieldId);
            return field ? field.valueType : "";
        },
        getOperators(filter) {
            const fieldType = this.getFieldType(filter.fieldId);
            const valueType = this.getFieldValueType(filter.fieldId);

            const operators = {
                string: [
                    { label: "İçerir", value: "contains" },
                    { label: "Eşittir", value: "equal" },
                    { label: "Eşit Değil", value: "not_equal" },
                    { label: "İle Başlar", value: "starts_with" },
                    { label: "İle Biter", value: "ends_with" },
                ],
                number: [
                    { label: "Eşittir", value: "equal" },
                    { label: "Eşit Değil", value: "not_equal" },
                    { label: "Büyüktür", value: "greater_than" },
                    { label: "Küçüktür", value: "less_than" },
                ],
                date: [
                    { label: "Önce", value: "before" },
                    { label: "Sonra", value: "after" },
                ],
                boolean: [
                    { label: "Eşittir", value: "equal" },
                    { label: "Eşit Değil", value: "not_equal" },
                ],
                dropdown: [
                    { label: "Eşittir", value: "equal" },
                    { label: "Eşit Değil", value: "not_equal" },
                    { label: "Şunlardan Biri", value: "is_one_of" },
                ],
                objectId: [
                    { label: "Eşittir", value: "equal" },
                    { label: "Eşit Değil", value: "not_equal" },
                    { label: "Şunlardan Biri", value: "is_one_of" },
                    { label: "Boş", value: "empty" },
                    { label: "Dolu", value: "not_empty" },
                ],
            };

            const fallback = [
                { label: "Boş", value: "empty" },
                { label: "Dolu", value: "not_empty" },
            ];

            return operators[valueType] || fallback;
        },
        getValueInputComponent(filter) {
            if (!filter.fieldId) return "a-input";

            const fieldType = this.getFieldType(filter.fieldId);
            const valueType = this.getFieldValueType(filter.fieldId);

            if (fieldType === "checkbox" || valueType === "boolean") {
                return "a-select";
            } else if (fieldType === "dropdown") {
                return "a-select";
            } else if (valueType === "date") {
                return "a-date-picker";
            } else if (valueType === "number") {
                return "a-input-number";
            } else {
                return "a-input";
            }
        },
        getFieldOptions(filter) {
            const field = this.getField(filter.fieldId);
            if (!field) return [];

            if (field.fieldType === "checkbox" || field.valueType === "boolean") {
                return [
                    { label: "True", value: true },
                    { label: "False", value: false },
                ];
            } else if (field.fieldType === "dropdown") {
                return field.options.dropdown.options.map((opt) => ({ label: opt.value, value: opt.value }));
            } else {
                return [];
            }
        },
        addFilter() {
            const newFilter = {
                fieldId: null,
                operator: null,
                value: null,
                mode: "dynamic",
            };
            this.clone.filters.push(newFilter);
        },
        removeFilter(index) {
            this.clone.filters.splice(index, 1);
        },
        onFieldChange(filter) {
            filter.operator = null;
            filter.value = null;
        },
        onModeChange(index, checked) {
            const mode = checked ? "static" : "dynamic";
            this.$set(this.clone.filters[index], "mode", mode);
            if (mode === "dynamic") {
                this.$set(this.clone.filters[index], "value", "");
            }
        },
        getFieldIcon(fieldId) {
            const fieldType = this.getFieldType(fieldId);
            switch (fieldType) {
                case "text":
                case "long-text":
                    return "text_fields";
                case "number":
                    return "looks_one";
                case "currency":
                    return "attach_money";
                case "datetime":
                    return "event";
                case "dropdown":
                    return "arrow_drop_down";
                case "checkbox":
                    return "check_box";
                case "url":
                    return "link";
                case "email":
                    return "email";
                case "phone":
                    return "phone";
                case "json":
                    return "code";
                case "file":
                    return "attachment";
                case "image":
                    return "image";
                case "video":
                    return "videocam";
                case "audio":
                    return "audiotrack";
                default:
                    return "help_outline";
            }
        },
    },
});
</script>

<style scoped lang="scss">
.block-editor.table-find-record {
    .wrapper {
        padding: 30px;
        display: flex;
        flex-direction: column;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .filter-actions {
            margin-bottom: 16px;
        }

        .filter-conditions {
            .filter-row {
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                justify-content: flex-start;
                gap: 10px;

                .mode-switch {
                    margin-left: auto;
                }

                .text-editor-wrapper {
                    flex: 1;
                    border-radius: 0px;
                    border: 1px solid #fff;
                    background: white;

                    &:hover {
                        border: 1px solid #006cff !important;
                    }
                }
            }
        }

        .filter-advanced-options {
            margin-top: 16px;
            display: flex;
            gap: 16px;

            .option-item {
                flex: 1;
            }

            .option-label {
                font-weight: 500;
                margin-bottom: 4px;
            }

            .option-description {
                font-size: 12px;
                color: #999;
                margin-bottom: 8px;
            }
        }
    }

    .custom-picker {
        width: max-content !important;
    }
}
</style>
